import { render, staticRenderFns } from "./MapLayerSettings.vue?vue&type=template&id=860fc0ee&scoped=true&"
import script from "./MapLayerSettings.vue?vue&type=script&lang=js&"
export * from "./MapLayerSettings.vue?vue&type=script&lang=js&"
import style0 from "./MapLayerSettings.vue?vue&type=style&index=0&id=860fc0ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860fc0ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VCheckbox,VIcon,VSlider})
